import { FeedPostDropDown, SVG, SocialCount } from "ui";
import LightBoxComments from "./LightBoxComments";
import LightBoxCommentForm from "./LightBoxCommentForm";

import img1 from "assets/img/posts/c1.jpg";
import img2 from "assets/img/posts/c2.jpg";
import img3 from "assets/img/posts/c3.jpg";
import img4 from "assets/img/posts/c4.jpg";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "services/redux/store";
import { allowScroll, stopScroll } from "services/redux/site/site";
import { closeLightBox } from "services/redux/lightbox/lightbox";
import { closeForm, openForm } from "services/redux/commentForm/commentForm";

const LightBox = () => {
    const open = useSelector((state: RootState) => state.lightbox.open);
    const dispatch = useDispatch<AppDispatch>();
    const [closeComments, setCloseComments] = useState(false);

    const images = [img1, img2, img3, img4];
    const [activeImg, setActiveImg] = useState({ img: img1, order: 1 });
    const handleSetActiveImg = (order: number) => {
        if (order < 1) {
            return;
        }
        if (order > images.length) {
            return;
        }
        setActiveImg({ img: images[order - 1], order });
    };

    useEffect(() => {
        if (open) {
            // dispatch(openForm());
            dispatch(stopScroll());
        } else {
            dispatch(allowScroll());
        }
    }, [open]);

    // useScrollLock();

    return (
        <div
            className={`custom-profile-lightbox is-fullscreen ${open ? "is-active" : ""}`}
        >
            <div className="lightbox-inner">
                <div
                    className={`image-side ${closeComments ? "full-image-side-inner" : ""}`}
                >
                    <div className="image-side-inner">
                        <div className="image-wrap">
                            {/* <div className="image-loader is-active">
                                <div className="loader is-loading"></div>
                            </div> */}
                            <div className="meta-overlay"></div>
                            <div
                                className={`meta-block ${
                                    closeComments ? "" : "hide-lightbox-meta"
                                }`}
                            >
                                <h3>
                                    Lorem ipsum dolor sit amet, consectetur
                                    adipiscing elit. Frater et T. Duo Reges:
                                    constructio interrete. Summae mihi videtur
                                    inscitiae. Esse enim, nisi eris, non potes.
                                </h3>
                                <p>
                                    Uploaded on <var id="lightbox-time"></var>
                                </p>
                            </div>
                            <div className="action-block">
                                {/* copy post drop down */}
                                <div
                                    className={`dropdown is-hoverable is-spaced is-right is-neutral dropdown-trigger`}
                                >
                                    <a className="action-button">
                                        <SVG
                                            svg="send"
                                            size={18}
                                            className="white-svg"
                                        />
                                    </a>
                                    <div className="dropdown-menu" role="menu">
                                        <div className="dropdown-content">
                                            <a
                                                href="#"
                                                className="dropdown-item"
                                            >
                                                <div className="media d-flex flex-j-start flex-a-center gap-10">
                                                    <SVG
                                                        svg="link-2"
                                                        size={18}
                                                        className="light-grey-svg"
                                                    />
                                                    <div className="media-content">
                                                        <h3>
                                                            Copy link to
                                                            Momeento
                                                        </h3>
                                                    </div>
                                                </div>
                                            </a>

                                            <a
                                                href="#"
                                                className="dropdown-item"
                                            >
                                                <div className="media d-flex flex-j-start flex-a-center gap-10">
                                                    <SVG
                                                        svg="bookmark"
                                                        size={18}
                                                        className="light-grey-svg"
                                                    />
                                                    <div className="media-content">
                                                        <h3>Momeento mark</h3>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                {/* message post to drop down */}
                                <div
                                    className={`dropdown is-hoverable is-spaced is-right is-neutral dropdown-trigger`}
                                >
                                    <a className="action-button">
                                        <SVG
                                            svg="arrow-out"
                                            size={18}
                                            className="white-svg"
                                        />
                                    </a>
                                    <div className="dropdown-menu" role="menu">
                                        <div className="dropdown-content">
                                            <a
                                                href="#"
                                                className="dropdown-item"
                                            >
                                                <div className="media d-flex flex-j-start flex-a-center gap-10">
                                                    <SVG
                                                        svg="arrow-out"
                                                        size={18}
                                                        className="light-grey-svg"
                                                    />
                                                    <div className="media-content">
                                                        <h3>
                                                            Message post to
                                                            friend
                                                        </h3>
                                                    </div>
                                                </div>
                                            </a>

                                            <a
                                                href="#"
                                                className="dropdown-item"
                                            >
                                                <div className="media d-flex flex-j-start flex-a-center gap-10">
                                                    <SVG
                                                        svg="community"
                                                        size={18}
                                                        className="light-grey-svg"
                                                    />
                                                    <div className="media-content">
                                                        <h3>
                                                            Message post to
                                                            community
                                                        </h3>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <a className="action-button">
                                    <SVG
                                        svg="repeat"
                                        size={18}
                                        className="white-svg"
                                    />
                                </a>
                                <a className="action-button">
                                    <SVG
                                        svg="heart"
                                        size={18}
                                        className="white-svg"
                                    />
                                </a>
                            </div>

                            <img
                                id="lightbox-image"
                                src={activeImg.img}
                                data-demo-src="assets/img/demo/unsplash/3.jpg"
                                alt=""
                            />
                            {activeImg.order == 1 ? (
                                ""
                            ) : (
                                <div
                                    className={`light-box-slider-arrow arrow-left`}
                                    onClick={() =>
                                        handleSetActiveImg(activeImg.order - 1)
                                    }
                                >
                                    <SVG
                                        svg={"chevron-left"}
                                        size={18}
                                        className="white-svg"
                                    />
                                </div>
                            )}
                            {activeImg.order == images.length ? (
                                ""
                            ) : (
                                <div
                                    className={`light-box-slider-arrow arrow-right`}
                                    onClick={() =>
                                        handleSetActiveImg(activeImg.order + 1)
                                    }
                                >
                                    <SVG
                                        svg={"chevron-right"}
                                        size={18}
                                        className="white-svg"
                                    />
                                </div>
                            )}
                        </div>

                        <div className="close-arrow-holder p-absolute d-flex flex-j-center flex-a-center">
                            <div
                                onClick={() =>
                                    setCloseComments(() => !closeComments)
                                }
                            >
                                <SVG
                                    svg="chevrons-right"
                                    size={24}
                                    className={`transition-svg white-svg ${closeComments ? "open" : ""}`}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className={`sidebar-side d-flex flex-col ${closeComments ? "is-hidden" : ""}`}
                    style={{ height: "100vh" }}
                >
                    {/* <div className="comments-loader is-active">
                        <div className="loader is-loading"></div>
                    </div> */}
                    {/* <div> */}
                    <div className="header">
                        <img
                            id="lightbox-avatar"
                            src="https://via.placeholder.com/300x300"
                            data-demo-src="assets/img/avatars/dan.jpg"
                            alt=""
                        />
                        <div className="user-meta">
                            <span id="lightbox-username">Dan Walker</span>
                            <span>
                                <small>2 hours ago</small>
                            </span>
                        </div>
                        <button
                            type="button"
                            className="button close-lightbox"
                            onClick={() => {
                                dispatch(closeLightBox());
                                dispatch(closeForm());
                            }}
                        >
                            Close
                        </button>
                        <div className="ml-10 light-box-dropdown">
                            <FeedPostDropDown />
                        </div>
                    </div>

                    <div className="inner-content">
                        <div className="live-stats">
                            <SocialCount allowComment={false} />
                        </div>
                    </div>
                    <LightBoxCommentForm />

                    <LightBoxComments />

                    {/* </div> */}
                </div>
            </div>
        </div>
    );
};

export default LightBox;
